import React from "react";
import { 
    useMediaQuery, 
    createTheme, 
    PaletteMode, 
    ThemeProvider as MuiThemeProvider,
    PaletteOptions,
    ThemeOptions, 
} from "@mui/material";
import { ReactChild, useMemo } from "react";
import { useSelector } from "react-redux";
import { IRootReducer } from "../redux/reducers";
import { getThemeMode } from "../redux/selectors/preferences.selectors";
import { generalTheme, IGeneralTheme, ITheme, lightTheme } from "../constants/theme";
import {} from "@mui/styles";

interface ThemeProviderProps {
    children: ReactChild;
}

interface AggumentedPaletteOptions {
    general: IGeneralTheme 
    theme: ITheme,
}

declare module '@mui/material' {
    interface PaletteOptions extends AggumentedPaletteOptions {}
}

declare module "@mui/styles" {
    interface DefaultTheme extends ThemeOptions{
        palette: AggumentedPaletteOptions & PaletteOptions 
    }
}

const ThemeProvider : React.FC<ThemeProviderProps> = ({ children }) => {
    const state = useSelector((state:IRootReducer) => state);
    const themeMode = getThemeMode(state);
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

    const mode:PaletteMode = useMemo(() => {
        const defaultMode = prefersDarkMode ? "light" : "light";
        switch(themeMode) {
            case 'light': 
                return "light"
            case "dark": 
                return "dark";
            case "default": 
                return defaultMode;
            default:
                return defaultMode;
        }
    }, [ themeMode, prefersDarkMode ]);

    const theme = React.useMemo(() => (
        createTheme({
        palette: {
            mode,
            primary: {
                main: "#263353",
            },
            secondary: {
                main: "#E76F51"
            },
            common: {
                
            },
            theme: mode === "dark" ? lightTheme : lightTheme,
            general: generalTheme
        },
        })
    ), [ mode ])

    return (
        <MuiThemeProvider theme={theme}>
            { children }
        </MuiThemeProvider>
    )
};

export default ThemeProvider;